import anew from './anew.vue'
export default anew